import React from 'react'
import { node, bool } from 'prop-types'
import { AuthenticationRequired } from 'mage-components'
import { selectors } from 'education-tools'
import { useSelector } from 'react-redux'
import CenteredLoader from './CenteredLoader'

AuthenticationFork.propTypes = {
  requireAuthentication: bool,
  children: node
}

function AuthenticationFork ({ requireAuthentication, children }) {
  const isAuthenticatedFeaturesLoaded = useSelector(selectors.isAuthenticatedFeaturesLoaded)

  if (requireAuthentication) {
    return (
      <AuthenticationRequired>
        {isAuthenticatedFeaturesLoaded ? children : <CenteredLoader />}
      </AuthenticationRequired>
    )
  }

  return children
}

export default AuthenticationFork
